<template>
  <div>
    <v-alert v-if="pedidosLiberados.msgErro != ''">
      {{ pedidosLiberados.msgErro }}
    </v-alert>

    <v-data-table
      v-else
      :loading="pedidosLiberados.carregando"
      loading-text="Buscando pedidos..."
      :items="pedidosDisponiveisSelecao()"
      :headers="headers"
      no-data-text="Nenhum pedido encontrado"
      no-results-text="Nenhum pedido localizado com esta pesquisa"
      single-expand
      show-expand
      item-key="id_pedido"
      :search="pesquisa"
      class="pedidos-liberados-dt"
      item-class="class-item"
    >
      <template v-slot:top>
        <v-text-field
          label="Pesquisar pedidos"
          v-model="pesquisa"
        ></v-text-field>
      </template>
      <template v-slot:[`item.add`]="{ item }">
        <v-btn
          depressed
          color="info"
          small
          rounded
          text
          class="blue lighten-5 blue--text-darken-4 font-weight-bold"
          @click="adicionarPedido(item)"
          >Adicionar</v-btn
        >
      </template>
      <template v-slot:[`item.cidade_entrega`]="{ item }">
        <btn-local-cliente-form-carga :pedido="item" />
      </template>
      <template v-slot:[`item.emissao`]="{ item }">
        {{ formatarData(item) }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="grey lighten-4 pb-2 pt-2">
          <v-card flat rounded="lg">
            <v-card-subtitle class="font-weight-bold"
              >Itens do pedido</v-card-subtitle
            >
            <v-card-text>
              <v-data-table
                :items="item.itens"
                :headers="headers_itens"
                dense
                hide-default-footer
                disable-sort
                class="pedidos-liberados-dt"
              ></v-data-table>
            </v-card-text>
          </v-card>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import BtnLocalClienteFormCarga from "./BtnLocalClienteFormCarga.vue";
export default {
  components: { BtnLocalClienteFormCarga },
  props: {},
  computed: {
    ...mapState("formacaoCarga", ["pedidosLiberados"]),
  },
  data: () => ({
    pesquisa: "",
    headers: [
      { text: "Filial", value: "filial_destino" },
      { text: "Pedido", value: "nr_pedido" },
      { text: "Emissão", value: "emissao" },
      { text: "Cliente", value: "nome_cliente" },
      { text: "Cidade", value: "cidade_entrega" },
      /*{ text: "Localização", value: "localizacao", align: "center" },*/
      { text: "Total Kgs", value: "total_kgs" },
      { text: "", value: "add" },
    ],
    headers_itens: [
      /* { text: "Gp", value: "gp" },
      { text: "Sgp", value: "sgp" },
      { text: "Item", value: "item" },*/
      { text: "Produto", value: "produto" },
      { text: "Emb", value: "embalagem" },
      { text: "Qtde kgs", value: "qtde_kgs" },
    ],
  }),
  methods: {
    ...mapMutations("formacaoCarga", ["adicionarPedido"]),
    ...mapActions("formacaoCarga", ["buscarPedidosLiberados"]),
    ...mapGetters("formacaoCarga", ["pedidosDisponiveisSelecao"]),
    formatarData(value) {
      return moment(value).format("DD/MM/yyyy");
    },
  },
  async mounted() {
    await this.buscarPedidosLiberados();
  },
};
</script>

<style>
.v-data-table.pedidos-liberados-dt
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td,
.v-data-table.pedidos-liberados-dt
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > td,
.v-data-table.pedidos-liberados-dt
  > .v-data-table__wrapper
  > table
  > tfoot
  > tr
  > td {
  font-size: 0.82rem !important;
}
</style>